var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "myfrom",
      staticClass: "demo-ruleForm",
      staticStyle: { position: "relative" },
      attrs: {
        "label-width": _vm.labelWidth,
        rules: _vm.rules,
        model: _vm.model,
        disabled: _vm.disabled,
        "label-position": _vm.labelPosition,
        inline: "",
      },
      nativeOn: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }